// @flow

// Add polifill To support IE < 11
// https://reactjs.org/blog/2017/09/26/react-v16.0.html#javascript-environment-requirements
import 'core-js/es6/map';
import 'core-js/es6/set';

// $FlowFixMe: required file-loader not found
require('file-loader?name=favicon.ico!./static/favicon.ico');
// $FlowFixMe: required file-loader not found
require('file-loader?name=[name].[ext]!./static/seek-icon-logo.png');
require('./static/manifest.json');

import {
  awsAccount,
  environment,
  version,
  metricsPrefix,
  metricsHost,
  metricsIsEnabled,
  jobTrackingEnabled
} from 'src/config';
import {
  serializeUnsentImpressions,
  forceTrackingRequest
} from 'src/modules/job-tracking';
import get from 'lodash/get';
import { logger } from 'src/modules/logger';
import { browserName } from 'src/modules/chalice-user-agent/browser-name';
import getLocale from 'src/modules/get-locale';
import VError from 'verror';

// Polyfill ES2015 promises
import Promise from 'bluebird';
window.Promise = window.Promise || Promise;

import ariaClick from 'src/modules/aria-click';
ariaClick(document);

import { setup as setupMetrics, metrics } from '@seek/metrics-js';
import pathnameToPageName from './pathnameToPageName';
import { isMobileUserAgent } from 'src/modules/chalice-user-agent/device-detect';

setupMetrics({
  host: metricsHost,
  isEnabled: metricsIsEnabled,
  prefix: metricsPrefix,
  globalTags: [
    `version:${version}`,
    `locale:${getLocale(window.location.hostname)}`,
    `environment:${environment}`,
    `aws-account:${awsAccount}`,
    `browser-name:${browserName(window.navigator.userAgent)}`,
    'platform:client',
    `device-type:${isMobileUserAgent() ? 'mobile' : 'desktop'}`,
    'Service_Name:chalice'
  ]
});

if (metricsIsEnabled) {
  metrics.sendPagePerformance([
    `houston-page:${pathnameToPageName(window.location.pathname)}`
  ]);
}

// Flush pending job tracking impressions
if (jobTrackingEnabled) {
  forceTrackingRequest().catch(err => {
    logger.warn({ err }, 'Impression tracking forceTrackingRequest error');
  });
}

// Serialize unsent tracking events before we leave the page.
window.addEventListener('beforeunload', () => {
  serializeUnsentImpressions();
});

// catch Bluebird promise unhandled rejections & errors
window.addEventListener('unhandledrejection', e => {
  e.preventDefault();
  const err = get(e, 'detail.reason') || get(e, 'detail') || e;

  if (err instanceof Error) {
    throw new VError(err, 'Unhandled rejection error');
  }
});

import clientRender from './client-render';
clientRender(document.getElementById('app'));
